import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setTokens } from "../../lib/api";
import { useAuth } from "../../stores/auth";

/** Seller portal (or other app) hands off tokens via hash after cross-origin sign-in. */
export function AuthCallback() {
  const navigate = useNavigate();
  const bootstrap = useAuth((s) => s.bootstrap);

  useEffect(() => {
    const hash = window.location.hash.replace(/^#/, "");
    const params = new URLSearchParams(hash);
    const access = params.get("access");
    const refresh = params.get("refresh");
    const next = params.get("next") || "/";
    if (access && refresh) {
      setTokens(access, refresh);
      window.history.replaceState(null, "", window.location.pathname);
      void bootstrap().then(() => {
        navigate(next.startsWith("/") ? next : "/", { replace: true });
      });
      return;
    }
    navigate("/login", { replace: true });
  }, [bootstrap, navigate]);

  return <p className="px-6 py-12 text-center text-sm text-white/50">Signing you in…</p>;
}
